<template>
    <nav class="footer-nav md:max-w-full w-full">
        <ul
            class="footer-nav__list flex flex-col md:flex-row md:w-full justify-between"
        >
            <!-- Chapter item -->
            <FooterNavChapterItem
                v-for="chapter in navList"
                :key="chapter.title"
                :chapter="chapter"
            />
        </ul>
    </nav>
</template>

<script setup lang="ts">
import { NavGroup } from "@academy/components";
import FooterNavChapterItem from "./FooterNavChapterItem.vue";

interface IFooterMainKidsProps {
    navList: NavGroup[];
}

defineProps<IFooterMainKidsProps>();
</script>

<style lang="scss" scoped>
.footer-nav {
    &__list {
        @include md() {
            gap: 1rem;
        }
    }
}
.active {
    @apply flex;
}
</style>
